import { createApp } from 'vue';
import { createPinia } from "pinia";
import VueFileAgent from './components/FileAgent/index';
import { vue3Debounce } from 'vue-debounce'
import { SlickList, SlickItem } from 'vue-slicksort';
import { createPersistedState } from 'pinia-plugin-persistedstate'
import tooltip from "@/directives/tooltip";

// @ts-ignore
function ConfigureApp(rootComponent: any) {

    const app = createApp(rootComponent)
        .use(PiniaInit())
        .directive('debounce', vue3Debounce({ lock: true })) //https://www.npmjs.com/package/vue-debounce#typescript-support
        .component('upload-input-with-button', require('./components/UploadInputWithButton.vue').default)
        .component('data-upload-grid', require('./components/DataUpload.vue').default)
        .component('data-upload-details', require('./components/DataUploadDetails.vue').default)
        .component('errors-warnings', require('./components/ErrorsAndWarnings.vue').default)
        .component('errors-warnings-update', require('./components/ErrorsAndWarningsUpdate.vue').default)
        .component('contacts-editor', require('./components/ContactsEditor.vue').default)
        .component('contacts-web-entry', require('./components/ContactsWebEntry.vue').default)
        .component('community-policing-web-entry', require('./components/CommunityPolicingWebEntry.vue').default)
        .component('community-policing-data-exporter', require('./components/CommunityPolicingDataExporter.vue').default)
        .component('reset-password', require('./components/ResetPassword.vue').default)
        .component('change-password', require('./components/ChangePassword.vue').default)
        .component('tasks', require('./components/Tasks.vue').default)
        .component('vfa-sortable-list', SlickList)
        .component('vfa-sortable-item', SlickItem)
        .component('audits', require('./components/Audits.vue').default)
        .component('audit-details', require('./components/AuditDetails.vue').default)
        .component('audit-document-templates', require('./components/AuditDocumentTemplates.vue').default)
        .use(VueFileAgent);

    app.directive("tooltip", tooltip);

    app.config.errorHandler = (err: any) => {
        console.error(err);
    }

    return app;
}

function PiniaInit() {
    var pinia = createPinia();

    //Plugins for pinia can be added below
    //pinia.use(<insert plugin function here>)
    pinia.use(createPersistedState({
        storage: sessionStorage,
    }))
    return pinia;
}
// @ts-ignore
window.$ConfigureApp = ConfigureApp;
